function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const MoneyIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 4h-3v1c0 1.103-.897 2-2 2s-2-.897-2-2V4H11v1c0 1.103-.897 2-2 2s-2-.897-2-2V4H4c-1.1 0-2 .9-2 2v22c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 23.996l-.004.004H4.003l-.004-.004V10h24v17.996zM9 6a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1zm14 0a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v4a1 1 0 0 0 1 1zm-5 6H8v2h8v4H8v2h8v4H8v2h10zm4 14h2V12h-4v2h2zm5.25 4.75H4.75c-1.1 0-2-.65-2-1.75v1c0 1.1.9 2 2 2h22.5c1.1 0 2-.9 2-2v-1c0 1.1-.9 1.75-2 1.75z"
  }));
};
export default MoneyIcon;